exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image {\n  border-radius: 32px;\n  height: 48px;\n  margin-bottom: 16px;\n  margin-left: 12px;\n  overflow: hidden;\n  width: 48px; }\n\n.attachment {\n  margin-bottom: 1.4em; }\n\n.file {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  .file-image {\n    width: 32px;\n    height: 32px;\n    overflow: hidden;\n    margin-right: 1em; }\n    @media screen and (min-width: 460px) {\n      .file-image {\n        width: 64px;\n        height: 64px; } }\n    .file-image img {\n      height: 100%;\n      width: auto; }\n  .file-info {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: center;\n        justify-content: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/replies/reply-item/reply-item.component.scss
// module id = ../../../../../src/app/replies/reply-item/reply-item.component.scss
// module chunks = 1